import React from "react";
import Intro from "./index/Intro";
import SectionFirst from "./index/SectionFirst";
import MissionVisionHistory from "./index/MissionVisionHistory";
import AboutUs from "./index/AboutUs";
import SkasDifference from "./index/SkasDifference";
import { useEffect, useState } from "react";
export const Body = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show the popup when the component mounts
    setShowPopup(true);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  return (
    <div className="overflow-x-hidden">
      <Intro />
      <MissionVisionHistory />
      <SkasDifference />
      <SectionFirst />
      <AboutUs />
      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg relative w-full max-w-sm mx-4 sm:mx-auto">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={handleClosePopup}
            >
              &#x2715; {/* Cross symbol */}
            </button>
            <img
              src="./assets/admissionPopup.jpeg" // Replace with your image URL
              alt="Popup"
              className="w-full h-auto "
            />
          </div>
        </div>
      )}
    </div>
  );
};
